import { AuthenticationService } from '@alfresco/adf-core';
import { Component, OnInit } from '@angular/core';
import { SolicitacaoService } from 'app/service/solicitacao/solicitacao.service';
import {MatDialog} from '@angular/material/dialog';
import { GraficoComponenteDialogComponent } from 'app/grafico-componente-dialog/grafico-componente-dialog.component';
import { ArmazemService } from 'app/service/endereco/armazem.service';
import { ModuloService } from 'app/service/endereco/modulo.service';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';



@Component({
  selector: 'app-grafico-alocacao',
  templateUrl: './grafico-alocacao.component.html',
  styleUrls: ['./grafico-alocacao.component.scss']
})
export class GraficoAlocacaoComponent implements OnInit {
  selectedModulo ;
  loading = false;
  posicoesHorizontalM = 0;
  posicoesVerticalM = 0;
  posicoesProfundidadeM = 0;
  tamanhoPosicaoPixelM : String;
  tamanhoPosicaoM = 0;
  pixelsTotalLarguraM : String;
  pixelsTotaAlturaM : String;
  paridadeM = true;
  divsM = [] ;
  qtdDivsM = 0;
  quantidadePosicoesM = 0;
  espacamentoM = 2;
  pixelsExibicaoM = "";
  divsParidadeM = [];
  adm = false;
  acervo = true;
  solicitacao = false;
  colorVerde = "#17aa5d";
  contadorLadoImpar = 0;
  contadorLadoPar = 0;
  modulos : any[];
  posicoesHorizontal = 0;
  posicoesVertical = 0;
  posicoesProfundidade = 0;
  quantidadePosicoes = 0;
  espacamento = 4;
  tamanhoPosicao = 90;
  tamanhoPosicaoPixels = "90px";
  pixelsTotalLargura = "";
  pixelsTotaAltura = "";
  divs = [];
  qtdDivs = 0;
  backgroundColor = "#9B111E";
  pixelsExibicao = "";
  itensExibicao = [];
  ordem = "DIREITA"
  marginTopTexto = "5px"
  colorText = "white";
  filhosComponent = [];
  componentSelected ;
  nameSelected = "";
  alocados ;
  marginLeftLado ;
  totalPixelsConteiner ;
  componentesHorizontal = [] ;
  capacidadeHorLabel = "0";
  capacidadeVertLabel = "0";
  percentualUtiLabel = "0";
  legendaCaixas = [];
  armazens : any[];
  resultArmazens ;
  eneableSelectArmazem = true;
  enebleSelectModulo = false;

  horizontalPosition: MatSnackBarHorizontalPosition = 'right';
 verticalPosition: MatSnackBarVerticalPosition = 'top';


  //configModulo :  ConfigModulo;



  //#EEAD2D AMARELO
  //"#17aa5d" VERDE
  //"#9B111E" VERMELHO
  constructor(private service : SolicitacaoService, public dialog: MatDialog,
    private authService: AuthenticationService,
    private armazemService : ArmazemService,
    private moduloService : ModuloService,
    private _snackBar: MatSnackBar

   ) {

    armazemService.listarArmazensUsuario().subscribe(data=>{
      this.resultArmazens = data;
      this.armazens =  this.resultArmazens ;
    })


    service.listarModulos().subscribe(data=>{

      this.modulos = data;
    }, error=>{
      console.error(error)
    })


    this.tamanhoPosicaoPixelM = "35px";
    this.tamanhoPosicaoM = 35;



   }

  ngOnInit() {

  }

  startModulo(){
    this.changeModulo(this.selectedModulo.id);
  }

  montarLegendaCaixas(){
    this.legendaCaixas = [];
    this.filhosComponent.forEach(element => {
      if(element.componentesFilhos.length > 0){

        element.componentesFilhos.forEach(filho => {
          if(filho.tipoCaixa != null && !this.isExistInArrayLegendaCaixas(this.legendaCaixas, filho) ){
            let obj = {"tipoId": filho.tipoCaixa.id, "descricaoCaixa" : filho.tipoCaixa.descricao, "cor": filho.tipoCaixa.cor}
            this.legendaCaixas.push(obj);
            // console.log(element)

          }
        });

      }
    });



  }

  isExistInArrayLegendaCaixas(array, element){
   let exist = false;
    array.forEach(elementArray => {
        if(elementArray.tipoId == element.tipoCaixa.id){
          exist = true;
        }
    });
    return exist;
  }

  changeModulo(valor){


    if(valor != "Selecione um Módulo..."){
      this.loading = true;
      this.service.listarComponentesModulo(valor).subscribe(data=>{
        this.zerarModulos();
        this.posicoesHorizontal = 0;
        this.posicoesVertical = 0;
        this.posicoesProfundidade = 0;
        this.divs = [];
       // this.divsParidade = [];
        // console.log(data)
        let modulo = this.getModuloById(valor);
        this.selectedModulo = modulo;
        this.filhosComponent = data;
        this.montarLegendaCaixas();
        this.ordem = modulo.ordenacao;
        this.paridadeM = modulo.paridade;
        // this.paridadeM = modulo.paridade;
        this.loading = false;
        this.posicoesHorizontalM = modulo.capacidadeHorizontal;
        if(this.posicoesHorizontalM < 10){
          this.tamanhoPosicaoPixelM = "60px";
          this.tamanhoPosicaoM = 60;
          this.marginTopTexto = "20px";
        }
        else{

          this.tamanhoPosicaoPixelM = "35px";
          this.tamanhoPosicaoM = 35;
          this.marginTopTexto = "5px"

        }
        this.posicoesVerticalM = data[0].componentesFilhos != null ? data[0].componentesFilhos.length : 1;
        this.posicoesProfundidadeM = 2;

        this.calcularQuantidade()
        this.calcularPosicoesModulo();
        this.capacidadeHorLabel =  this.posicoesHorizontalM+"";
        this.capacidadeVertLabel =  this.posicoesVerticalM+"";

        if(this.paridadeM){
          this.capacidadeHorLabel =  this.posicoesHorizontalM  * 2 +"";
          this.posicoesProfundidadeM =  this.posicoesProfundidadeM / 2;
          this.divsParidadeM.push("LADO PAR");
          this.divsParidadeM.push("LADO IMPAR");
        }else{
          this.divsParidadeM.push(" -");
        }


      }, error=>{
        console.error(error)
        this.loading = false;
      })


    }else{

    }
  }


  changeArmazem(valor){
    // console.log(valor)
    if(valor != "Selecione um armazem..."){
      this.moduloService.getModuloByArmazem(valor).subscribe(data=>{
         this.modulos = data;
         if(this.modulos.length == 0){
            this.openSnackBarError("Nenhum módulo encontrado para este armazem ! ")
         }else{
           this.eneableSelectArmazem = false;
           this.enebleSelectModulo = true;
         }
      })
    }

  }

  zerarModulos(){
    this.posicoesHorizontalM = 0;
    this.posicoesVerticalM = 0;
    this.posicoesProfundidadeM = 0;
    this.divsM = [];
    this.divsParidadeM = [];
    this.itensExibicao = [];
  }


  getModuloById(id){
    let modulo = null;
    this.modulos.forEach(element => {
        if(element.id == id){
          modulo = element;
        }
    });

    return modulo;
  }

  buscarFilhoPosicao(posicaoH, posicaoV){


    this.componentSelected = null;
    this.filhosComponent.forEach(element => {
      element.componentesFilhos.forEach(element2 => {
          if(element2.posicaoHorizontal == posicaoH && posicaoV == element2.posicaoVertical){
            this.componentSelected = element2;
          }
      });
    });

    let largura;
    if (innerWidth < 400) {
      largura = innerWidth - 50 + 'px';
    } else {
      largura = innerWidth - innerWidth / 2 + 'px';
    }

    // console.log(this.componentSelected);
    if (this.componentSelected.ativo === true) {
      const dialogRef = this.dialog.open(GraficoComponenteDialogComponent, {
        data: { componente: this.componentSelected},
        width: largura
      });
    }

    /*this.montarComponenteFilho(this.componentSelected);*/

  }

  montarComponenteFilho(obj){

    this.nameSelected = obj.nome;
      if(obj.isAlocacaoRecipiente){
        this.service.listarAlocacao(obj.id).subscribe(data=>{
          this.alocados = data;
          // console.log(data)
          this.posicoesHorizontalM = 0;
          this.posicoesVerticalM = 0;
          this.divsM = [];
          this.divsParidadeM = [];

          this.posicoesHorizontal = obj.qtdComponenteAlocavel.qtdHorizontal;
          this.posicoesVertical = obj.qtdComponenteAlocavel.qtdVertical;
          this.posicoesProfundidade = obj.qtdComponenteAlocavel.qtdProfundidade;
          this.calcularQuantidade();

        }, error=>{
          this.alocados = [] ;
          console.error(error)
        })




      }
  }



  returnColor(posicaoH, posicaoV) : String{

    let cor = "#17aa5d";
    this.filhosComponent.forEach(element => {
      element.componentesFilhos.forEach(element2 => {
          if(element2.posicaoHorizontal == posicaoH && posicaoV == element2.posicaoVertical){
            if(element2.tipoCaixa.cor != ""){
              cor = element2.tipoCaixa.cor;
            }else{
              cor = element2.cor;
            }


            //cor forEach;
          }

      });
    });
    return cor;
  }

  isAtivo(posicaoH, posicaoV) : boolean{

    let ativo = true;
    this.filhosComponent.forEach(element => {
      element.componentesFilhos.forEach(element2 => {
          if(element2.posicaoHorizontal == posicaoH && posicaoV == element2.posicaoVertical){
            if(element2.ativo == false){
              ativo = false;
            }

          }

      });
    });
    return ativo;
  }

  calcularPosicoesModulo(){


    this.quantidadePosicoesM = (this.posicoesVerticalM * this.posicoesHorizontalM) * this.posicoesProfundidadeM;

    this.pixelsExibicaoM = (this.tamanhoPosicaoM *  this.posicoesProfundidadeM) +  (((this.espacamentoM * 2 ) * (this.posicoesProfundidadeM - 1)) +  (this.espacamentoM * 2 )) + "px";

    this.pixelsTotalLarguraM = (this.posicoesHorizontalM * this.tamanhoPosicaoM) + (((this.espacamentoM * 2 ) * (this.posicoesHorizontalM - 1)) +  (this.espacamentoM * 2 )) + 20 + "px";
    let widthSemPixels = (this.posicoesHorizontalM * this.tamanhoPosicaoM) + (((this.espacamentoM * 2 ) * (this.posicoesHorizontalM - 1)) +  (this.espacamentoM * 2 ));

    this.totalPixelsConteiner = (widthSemPixels + 40) + "px"


    this.marginLeftLado =  ((widthSemPixels - (widthSemPixels / 4)) / 2) +"px"
    // console.log( this.marginLeftLado + "margin")


    this.pixelsTotaAlturaM = (this.posicoesVerticalM * this.tamanhoPosicaoM) +  (((this.espacamentoM * 2 ) * (this.posicoesVerticalM - 1)) + (this.espacamentoM * 2 )) + 40  + "px";
    this.qtdDivsM = this.quantidadePosicoesM / this.posicoesProfundidadeM;


    for(let m = 0 ; m < this.posicoesHorizontalM ; m ++){
      this.componentesHorizontal.push(m);
    }

    // console.log(this.componentesHorizontal)
    let altura = this.posicoesVerticalM;
    let posicaoLinha = 1;
    if(this.ordem == "ESQUERDA"){
      posicaoLinha = this.posicoesHorizontalM;
    }
    // console.log("posicaoLinha  " + posicaoLinha);
    // console.log(this.paridadeM);
    for(let i = 0 ; i < this.qtdDivsM ; i++ ){

      if(this.ordem == "ESQUERDA"){

        let obj = {"posicao" : posicaoLinha, "altura": altura};
        this.divsM.push(obj);
        posicaoLinha --;
        if( posicaoLinha < 1){
          posicaoLinha = this.posicoesHorizontalM;
          altura --;
        }

      }else{

        let obj = {"posicao" : posicaoLinha, "altura": altura};
        this.divsM.push(obj);
        posicaoLinha ++;
        if( posicaoLinha > this.posicoesHorizontalM){
          posicaoLinha = 1;
          altura --;
        }

      }




    }


  }

  alinhamentoPosicao(pari, posicao){

    if(pari == "LADO PAR"){

     if((this.posicoesHorizontalM *2 ) == posicao){
        return '30px';
     }else{
        return '55px';
     }

    }else if(pari == "LADO IMPAR"){
      if(((this.posicoesHorizontalM * 2) - 1) == posicao){
        return '30px';
     }else{
        return '55px';
     }
    }

  }

  validaParidade(posicao, pari){
    if(this.paridadeM){
        if(pari == "LADO PAR"){

            return posicao + posicao;

        }else if (pari == "LADO IMPAR"){

            return (posicao - 1) + posicao  ;

        }

    }else{
      return posicao;
    }
  }




  calcularQuantidade(){


    this.quantidadePosicoes = (this.posicoesVertical * this.posicoesHorizontal) * this.posicoesProfundidade;

    this.pixelsExibicao = (this.tamanhoPosicao *  this.posicoesProfundidade) +  (((this.espacamento * 2 ) * (this.posicoesProfundidade - 1)) +  (this.espacamento * 2 )) + "px";

    // console.log(this.pixelsExibicao)

    this.pixelsTotalLargura = (this.posicoesHorizontal * this.tamanhoPosicao) + (((this.espacamento * 2 ) * (this.posicoesHorizontal - 1)) +  (this.espacamento * 2 )) + "px";
    this.pixelsTotaAltura = (this.posicoesVertical * this.tamanhoPosicao) +  (((this.espacamento * 2 ) * (this.posicoesVertical - 1)) + (this.espacamento * 2 ))  + "px";
    this.qtdDivs = this.quantidadePosicoes / this.posicoesProfundidade;
    //let linha = 1;
    let altura = 1;
    let posicaoLinha = 1;
    for(let i = 0 ; i < this.qtdDivs ; i++ ){
      let obj = {"posicao" : posicaoLinha, "altura": altura};
      this.divs.push(obj);
      posicaoLinha ++;
      if( posicaoLinha > this.posicoesHorizontal){
        posicaoLinha = 1;
        altura ++;
      }
    }

  }



  calcularPosicao(obj){

    if(obj.altura == this.posicoesVertical){
      return (obj.posicao * this.posicoesProfundidade) - (this.posicoesProfundidade - 1)
    }
    else{
       let multiplicador = this.posicoesVertical - obj.altura;
       let t = (((this.posicoesHorizontal * multiplicador) *  this.posicoesProfundidade ) + (obj.posicao * this.posicoesProfundidade)  - (this.posicoesProfundidade - 1));

       return t;
    }

  }

  testarMetodo(){
    return this.pixelsTotaAltura;
  }

  calcularCor(obj) : string{
    let posicaoPai = 0;

    if(obj.altura == this.posicoesVertical){
      posicaoPai = (obj.posicao * this.posicoesProfundidade) - (this.posicoesProfundidade - 1)
    }
    else{
       let multiplicador = this.posicoesVertical - obj.altura;
       let t = (((this.posicoesHorizontal * multiplicador) *  this.posicoesProfundidade ) + (obj.posicao * this.posicoesProfundidade)  - (this.posicoesProfundidade - 1));

       posicaoPai = t;
    }
    let inicial = posicaoPai ;
    let array = [];
    for( let i = 0; i < this.posicoesProfundidade; i ++){
      array.push(inicial)
      inicial ++;
    }
    let qtdEncontrada = 0 ;
    array.forEach(element => {
      this.alocados.forEach(element2 => {
        if(element == element2.posicao){
          qtdEncontrada ++;
        }
      });
    });

    let color = "#17aa5d";
    if(qtdEncontrada  == this.posicoesProfundidade){
      color ="#9B111E";
    }else if(qtdEncontrada > 0 && qtdEncontrada  < this.posicoesProfundidade){
      color ="#EEAD2D";
    }

    return color;

  }



  detalharPosicao(obj){

    if(this.itensExibicao.length > 0){
      this.itensExibicao = [];
    }else{

      this.itensExibicao = [];
      // console.log(obj)
      let posicaoPai = 0;

      if(obj.altura == this.posicoesVertical){
        posicaoPai = (obj.posicao * this.posicoesProfundidade) - (this.posicoesProfundidade - 1)
      }
      else{
        let multiplicador = this.posicoesVertical - obj.altura;
        let t = (((this.posicoesHorizontal * multiplicador) *  this.posicoesProfundidade ) + (obj.posicao * this.posicoesProfundidade)  - (this.posicoesProfundidade - 1));

        posicaoPai = t;
      }



      for(let i = 0 ; i < this.posicoesProfundidade; i++){
        let encontrado = false;
        let cor = "#17aa5d";
        this.alocados.forEach(element2 => {
          if(posicaoPai == element2.posicao){
            encontrado = true;
          }
        });
        if(encontrado){
          cor = "#9B111E"
        }
        let item = {"posicao": posicaoPai, "cor" :cor}
        this.itensExibicao.push(item);
        posicaoPai ++;
      }

    }


  }


  openSnackBarSuccess(message: string) {
    this._snackBar.open(message, '', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 4000,
      panelClass: ['success-snackbar']
    });
  }

  openSnackBarError(message: string) {
    this._snackBar.open(message,'', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 3000,
      panelClass: ['error-snackbar']
    });
  }

}



// WEBPACK FOOTER //
// /app/src/app/grafico-alocacao/grafico-alocacao.component.ts